import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ErrorsDisplayContainer } from "../../error-display";
import { TopCalendarPicker } from "./top-calendar.picker";
import { TopCalendarPanelStyled } from "./top-calendar.styled";

interface IRideCalendarPanel {
  dateFrom: TDateISO;
  dateTo: TDateISO;
  setDateFrom: (dt: TDateISO) => void;
  setDateTo: (dt: TDateISO) => void;
  errors: string[];
}

export const TopCalendarPanel: FC<IRideCalendarPanel> = ({
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  errors,
}) => {
  const { t } = useTranslation();
  return (
    <TopCalendarPanelStyled>
      <div className="pickers_container">
        <TopCalendarPicker
          date={dateFrom}
          setDate={setDateFrom}
          label={t("general.FROM_DATE")}
        />
        <TopCalendarPicker
          date={dateTo}
          setDate={setDateTo}
          label={t("general.UNTIL_DATE")}
        />
      </div>
      {Boolean(errors?.length) && (
        <ErrorsDisplayContainer serverErrors={errors} />
      )}
    </TopCalendarPanelStyled>
  );
};
